// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eDHB","type":"styles_type__3jFKD","choices":"styles_choices__1l-p2"};